import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function ObjectionsSection() {
  const faqs = [{
    question: 'Are there hidden costs I should know about?',
    answer: "We believe in total transparency. Beyond the quote, the only potential extra cost is if your electrical panel needs an upgrade (for electric systems) or gas line work (for hydronic). We assess this upfront so you aren't surprised. Operating costs vary by winter severity, but we can give you a realistic estimate based on local data."
  }, {
    question: 'Do I have to tear up my existing driveway?',
    answer: "Honest answer: Usually, yes. To install the heating elements properly and ensure longevity, they need to be embedded in a new layer. The best time to install SunFlow is when you're already planning to repave. However, for some concrete surfaces, we can sometimes retrofit using saw-cut technology, but it's case-by-case."
  }, {
    question: 'Does it actually work in heavy Ontario snowstorms?',
    answer: 'Yes. Our systems are designed specifically for the Canadian climate. The sensors activate the system *before* snow accumulates, melting it as it falls. In extremely heavy blizzards (12"+ at once), the system might need a little time to catch up, but it will keep the surface passable and prevent ice bonding.'
  }, {
    question: 'What if the system breaks? Can it be repaired?',
    answer: "This is a common fear. Electric cables rarely fail because they have no moving parts. If a cable is damaged (e.g., by a contractor drilling), we have tools to locate the exact break point and repair just that spot without ripping up the whole driveway. Hydronic PEX tubing is incredibly durable; usually, it's the boiler (accessible in your garage/mechanical room) that needs maintenance, not the driveway itself."
  }, {
    question: 'Is this really worth the investment?',
    answer: "It depends on what you value. If you enjoy shoveling or have a very cheap, reliable plow guy, maybe not. But if you value safety (no ice), convenience (never waiting for a plow), protecting your home's value, and aging in place without worry, then our customers say it's absolutely worth it. It also adds tangible resale value to your home."
  }];
  return <section className="py-16 bg-slate-50 md:py-24" data-id="element-1022">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1023">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1024">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-1025">
            Honest Answers to Common Concerns
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-1026">
            We believe transparency builds trust. Here are the tough questions
            skeptical homeowners ask—and our straight answers.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-1027">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-1028" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-slate-200 rounded-lg overflow-hidden bg-white shadow-sm" data-id="element-1029">
      <button className="flex items-center justify-between w-full p-5 text-left bg-white hover:bg-slate-50 transition-colors" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-1030">
        <span className="font-bold text-slate-900 text-lg" data-id="element-1031">{question}</span>
        {isOpen ? <ChevronUp className="h-5 w-5 text-primary shrink-0 ml-4" data-id="element-1032" /> : <ChevronDown className="h-5 w-5 text-slate-400 shrink-0 ml-4" data-id="element-1033" />}
      </button>
      <div className={`bg-slate-50/50 transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 p-5 border-t border-slate-100' : 'max-h-0 opacity-0 overflow-hidden'}`} data-id="element-1034">
        <p className="text-slate-700 leading-relaxed" data-id="element-1035">{answer}</p>
      </div>
    </div>;
}